"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VWO_ACCOUNT_ID = exports.PROGRAM = exports.MEMBER = exports.HEAP_ACCOUNT_ID = void 0;
const HEAP_ACCOUNT_ID = exports.HEAP_ACCOUNT_ID = "991350086";
const VWO_ACCOUNT_ID = exports.VWO_ACCOUNT_ID = 310341;
const PROGRAM = exports.PROGRAM = {
  key: "",
  ocid: "",
  name: ""
};
const MEMBER = exports.MEMBER = {
  member_key: "",
  member_id: "",
  first_name: "",
  last_name: ""
};